/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-02 11:21:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-24 15:15:19
 */
//静态资源上传
import http from '../httpConfig'


//判断微软云上传还是本地上传
export const local_or_azure = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/api/system/config/info/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


//本地附件上传
export const upload_static_File = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.uploadFile('/api/fileManager/upload-file/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}



